module.exports = __webpack_public_path__ + "img/0Q3B7166_FoamcoreMatted_MockedUp.de68d4f9.jpg";